export const getUsage = 'getUsage';
export const getTotalUsage = 'getTotalUsage';
export const getTotalInitUsage = 'getTotalInitUsage';
export const getTotalContUsage = 'getTotalContUsage';
export const getAvgUsage = 'getAvgUsage';
export const getCollectionUsage = 'getCollectionUsage';
